import {
  Description,
  Pause,
  PlayArrow,
  Speed,
  VolumeOff,
  VolumeUp,
  ExpandMore,
  ExpandLess
} from '@mui/icons-material';
import {
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Slider,
  Typography,
  Paper,
  Collapse
} from '@mui/material';
import React from 'react';

const PLAYBACK_SPEED_OPTIONS = [1, 1.25, 1.5, 2];

const flexCenter = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}

export function PlayPauseButton({
  classes,
  duration,
  play,
  togglePlay,
  audio
}) {
  return (
    <Grid item className={classes.iconCenter} xs={1}>
      <IconButton
        size="small"
        disabled={!duration || !audio}
        onClick={togglePlay}
        children={
          play ? (
            <Pause className={classes.iconSmall} />
          ) : (
            <PlayArrow className={classes.iconSmall} />
          )
        }
      />
    </Grid>
  );
}

export function DurationField({
  classes,
  formatDuration,
  currentTime,
  duration
}) {
  return (
    <Grid item className={classes.iconCenter} xs={3}>
      <Typography
        children={`${formatDuration(currentTime)} / ${formatDuration(
          duration
        )}`}
      />
    </Grid>
  );
}

export function ProgressSlider({
  progressSliderXs,
  classes,
  audio,
  isPlayable,
  currentTime,
  duration,
  handleChangeTime,
}) {
  return (
    <Grid item xs={progressSliderXs} className={classes.iconCenter}>
      <Slider
        disabled={
          !duration ||
          duration === Infinity ||
          !audio ||
          !isPlayable
        }
        classes={{ root: classes.slider, thumb: classes.thumb }}
        value={currentTime === 0 ? 0 : (currentTime * 100) / duration || 0}
        onChange={handleChangeTime}
        aria-labelledby="continuous-slider"
      />
    </Grid>
  );
}

export function AnalyseIADisplay({ analyseIA }) {
  const [open, setOpen] = React.useState(false);

  const handleToggle = () => {
    setOpen(!open);
  };

  return (
    <Grid container spacing={2} sx={{ mb: 2 }}>
      <Grid item xs={12}>
        <Paper
          elevation={1}
          sx={{ p: 2 }}
        >
          <Typography
            variant="subtitle1"
            color="primary"
            onClick={handleToggle}
            sx={{
              cursor: 'pointer',
              display: 'flex',
              justifyContent: 'space-between'
            }}
          >
            Résumé: ({analyseIA.type})
            <IconButton
              size="small"
              sx={{ ml: 1 }}
            >
              {open ?
                <ExpandLess fontSize="small" /> :
                <ExpandMore fontSize="small" />
              }
            </IconButton>
          </Typography>
          <Collapse in={open}>
            <Typography
              sx={{ mt: 2 }}
              dangerouslySetInnerHTML={{ __html: analyseIA.summary }}
            />
          </Collapse>
        </Paper>
      </Grid>
    </Grid>
  );
}

export function VolumeManager({
  mouseOn,
  classes,
  audio,
  isPlayable,
  volume,
  duration,
  setState,
  handleChangeVolume,
  mute,
}) {
  return (
    <Grid
      item
      xs={1}
      onMouseLeave={() => {
        setState({ mouseOn: false });
      }}
      onMouseEnter={() => {
        setState({ mouseOn: true });
      }}
      sx={{ position: 'relative', display: 'flex', justifyContent: 'center' }}
    >
      {/* Sound slider */}
      {mouseOn && (
        <Slider
          disabled={!duration || !audio || !isPlayable}
          classes={{ thumb: classes.volumeThumb, track: classes.track }}
          value={volume === 0 ? 0 : volume * 100 || 100}
          onChange={handleChangeVolume}
          aria-labelledby="continuous-slider"
          orientation="vertical"
          sx={{
            position: 'absolute',
            bottom: '100%',
            zIndex: 10,
          }}
        />
      )}
      {/* Sound icon */}
      <IconButton onClick={mute} size="small" disabled={!isPlayable}>
        {volume ? (
          <VolumeUp className={classes.iconSmall} />
        ) : (
          <VolumeOff className={classes.iconSmall} />
        )}
      </IconButton>
    </Grid>
  );
}

export function CopyLink({ classes, copieLink, props }) {
  return (
    <Grid item xs={1} sx={flexCenter}>
      <IconButton
        size="small"
        onClick={(e) => copieLink(e, props.url)}
        children={<Description className={classes.iconSmall} />}
      />
    </Grid>
  );
}

export function AudioSpeedManager({
  classes,
  handleOpenPlaybackSpeed,
  handleClosePlaybackSpeed,
  handleChangePlaybackSpeed,
  playbackSpeed,
  playbackSpeedAnchor,
}) {
  return (
    <Grid item xs={1} className={classes.iconCenter}>
      <IconButton size="small" onClick={handleOpenPlaybackSpeed}>
        <Speed className={classes.iconSmall} />
        <Typography sx={{ fontSize: '10', marginLeft: '0', color: 'black' }}>
          {playbackSpeed}x
        </Typography>
      </IconButton>
      <Menu
        anchorEl={playbackSpeedAnchor}
        open={Boolean(playbackSpeedAnchor)}
        onClose={handleClosePlaybackSpeed}
      >
        {PLAYBACK_SPEED_OPTIONS.map((speed) => (
          <MenuItem
            key={speed}
            selected={playbackSpeed === speed}
            onClick={() => handleChangePlaybackSpeed(speed)}
          >
            {speed}x
          </MenuItem>
        ))}
      </Menu>
    </Grid>
  );
}
